import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { f as t } from "../../../../../chunks/vec4f32.js";
import e from "../../../../webgl/BufferObject.js";
import "../../../../webgl/FramebufferObject.js";
import "../../../../../core/has.js";
import "../../../../webgl/checkWebGLError.js";
import "../../../../webgl/enums.js";
import "../../../../../chunks/builtins.js";
import { createProgram as r } from "../../../../webgl/programUtils.js";
import i from "../../../../webgl/Texture.js";
import s from "../../../../webgl/VertexArrayObject.js";
import o from "./WGLBrush.js";
import { background as n } from "../shaders/BackgroundPrograms.js";
import { tileInfo as a } from "../shaders/TileInfoPrograms.js";
var l = 300,
    u = 32;

var m = /*#__PURE__*/function (_o) {
  _inherits(m, _o);

  var _super = _createSuper(m);

  function m() {
    var _this;

    _classCallCheck(this, m);

    _this = _super.apply(this, arguments), _this._color = t(1, 0, 0, 1);
    return _this;
  }

  _createClass(m, [{
    key: "dispose",
    value: function dispose() {
      this._outlineProgram && (this._outlineProgram.dispose(), this._outlineProgram = null), this._tileInfoProgram && (this._tileInfoProgram.dispose(), this._tileInfoProgram = null), this._outlineVertexArrayObject && (this._outlineVertexArrayObject.dispose(), this._outlineVertexArrayObject = null), this._tileInfoVertexArrayObject && (this._tileInfoVertexArrayObject.dispose(), this._tileInfoVertexArrayObject = null), this._canvas = null;
    }
  }, {
    key: "prepareState",
    value: function prepareState(_ref) {
      var t = _ref.context;
      t.setBlendingEnabled(!0), t.setBlendFunctionSeparate(1, 771, 1, 771), t.setColorMask(!0, !0, !0, !0), t.setStencilWriteMask(0), t.setStencilTestEnabled(!1);
    }
  }, {
    key: "draw",
    value: function draw(t, e) {
      var r = t.context;
      if (!e.isReady) return;
      this._loadWGLResources(r), r.bindVAO(this._outlineVertexArrayObject), r.useProgram(this._outlineProgram), this._outlineProgram.setUniformMatrix3fv("u_dvsMat3", e.transforms.dvs), this._outlineProgram.setUniform2f("u_coord_range", e.rangeX, e.rangeY), this._outlineProgram.setUniform1f("u_depth", 0), this._outlineProgram.setUniform4fv("u_color", this._color), r.drawArrays(3, 0, 4);

      var i = this._getTexture(r, e);

      i ? (r.bindVAO(this._tileInfoVertexArrayObject), r.useProgram(this._tileInfoProgram), r.bindTexture(i, 0), this._tileInfoProgram.setUniformMatrix3fv("u_dvsMat3", e.transforms.dvs), this._tileInfoProgram.setUniform1f("u_depth", 0), this._tileInfoProgram.setUniform2f("u_coord_ratio", e.rangeX / e.width, e.rangeY / e.height), this._tileInfoProgram.setUniform2f("u_delta", 8, 8), this._tileInfoProgram.setUniform2f("u_dimensions", i.descriptor.width, i.descriptor.height), r.drawArrays(5, 0, 4), r.bindVAO()) : r.bindVAO();
    }
  }, {
    key: "_loadWGLResources",
    value: function _loadWGLResources(t) {
      if (this._outlineProgram && this._tileInfoProgram) return;

      var i = r(t, n),
          o = r(t, a),
          l = {
        geometry: [{
          name: "a_pos",
          count: 2,
          type: 5120,
          offset: 0,
          stride: 2,
          normalized: !1,
          divisor: 0
        }]
      },
          u = new Int8Array([0, 0, 1, 0, 1, 1, 0, 1]),
          _m = e.createVertex(t, 35044, u),
          f = new s(t, n.attributes, l, {
        geometry: _m
      }),
          c = new Int8Array([0, 0, 1, 0, 0, 1, 1, 1]),
          h = e.createVertex(t, 35044, c),
          g = new s(t, a.attributes, l, {
        geometry: h
      });

      this._outlineProgram = i, this._tileInfoProgram = o, this._outlineVertexArrayObject = f, this._tileInfoVertexArrayObject = g;
    }
  }, {
    key: "_getTexture",
    value: function _getTexture(t, e) {
      if (e.texture && e.triangleCountReportedInDebug === e.triangleCount) return e.texture;
      e.triangleCountReportedInDebug = e.triangleCount, this._canvas || (this._canvas = document.createElement("canvas"), this._canvas.setAttribute("id", "canvas2d"), this._canvas.setAttribute("width", "".concat(l)), this._canvas.setAttribute("height", "".concat(u)), this._canvas.setAttribute("style", "display:none"));
      var r = e.triangleCount;
      var s = e.key.id;
      e.triangleCount > 0 && (s += ", ".concat(r));
      var o = this._canvas,
          n = o.getContext("2d");
      return n.font = "24px sans-serif", n.textAlign = "left", n.textBaseline = "top", n.clearRect(0, 0, l, u), r > 1e5 ? (n.fillStyle = "red", n.fillRect(0, 0, l, u), n.fillStyle = "black") : (n.clearRect(0, 0, l, u), n.fillStyle = "blue"), n.fillText(s, 0, 0), e.texture = new i(t, {
        target: 3553,
        pixelFormat: 6408,
        dataType: 5121,
        samplingMode: 9728,
        wrapMode: 33071
      }, o), e.texture;
    }
  }]);

  return m;
}(o);

export { m as default };